import Vue from "vue";
import Router from "vue-router";
import store from "./store";

import Layout from "./components/DefaultLayout.vue";

// DASHBOARD
import Dashboard from "./views/Dashboard/Dashboard.vue";
// LOGIN
import Login from "./views/Login/Login.vue";
import HeaderFooter from "./views/Login/headerFooter.vue";
import Homep from "./views/Login/homep.vue";
import ForgotPassword from "./views/Login/forgotPassword.vue";

// Company
import Company from "./views/Company/company.vue";
import EditCompany from "./views/Company/editCompany.vue";

// USER
import User from "./views/Users/user.vue";
import EditUser from "./views/Users/editUser.vue";
import CreateUser from "./views/Users/createUser.vue";
// USER -> CHANGE PASSWORD
import ChangePassword from "./views/Users/changePassword.vue";

//TEACHER
import Teacher from "./views/Teacher/teacher.vue";
import CreateTeacher from "./views/Teacher/createTeacher.vue";
import EditTeacher from "./views/Teacher/editTeacher.vue";

//GENERAL
import General from "./views/General/general.vue";
import CreateCountry from "./views/General/createCountry.vue";
import CreateUniversity from "./views/General/createUniversity.vue";
import CreateCourse from "./views/General/createCourse.vue";
import CreateLevel from "./views/General/createLevel.vue";
import CreateSubmission from "./views/General/createSubmission.vue";
import CreateOffer from "./views/General/createOffer.vue";
import EditCountry from "./views/General/editCountry.vue";
import EditUniversity from "./views/General/editUniversity.vue";
import EditCourse from "./views/General/editCourse.vue";
import EditLevel from "./views/General/editLevel.vue";
import EditSubmission from "./views/General/editSubmission.vue";
import EditOffer from "./views/General/editOffer.vue";

//LEAD
import Lead from "./views/Lead/lead.vue";
import CreateLead from "./views/Lead/createLead.vue";
import EditLead from "./views/Lead/editLead.vue";
import ViewLead from "./views/Lead/viewLead.vue";

//TRAINING
import Training from "./views/Training/training.vue";
import CreateTraining from "./views/Training/createTraining.vue";
import EditTraining from "./views/Training/editTraining.vue";
import ImageUpload from "./views/Training/imageUpload.vue";
import EditDetails from "./views/Training/editDetails.vue";
import RegistrationEdit from "./views/Training/registrationEdit.vue";

//TRAININGTYPE
import TrainingType from "./views/TrainingType/trainingType.vue";
import CreateTrainingType from "./views/TrainingType/createTrainingType.vue";
import EditTrainingType from "./views/TrainingType/editTrainingType.vue";

//Application
import Application from "./views/Application/application.vue";
import CreateApplication from "./views/Application/createApplication.vue";
import ApplicationDetail from "./views/Application/applicationDetail.vue";

Vue.use(Router);

const router = new Router({

  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  
  // mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      component: Login,
      meta: {
        transitionName: 'slide'
      }
    },
    {
      path: "/homep",
      component: Homep,
      meta: {
        transitionName: 'slide'
      }
    },
    
    {
      path: "/registration",
      component: ForgotPassword,
      meta: {
        transitionName: 'slide'
      }
    },
    
    {
      path: "/",
      component: Layout,
      meta: {
        requiresAuth: true,
        transitionName: 'slide'
      },
      children: [
        {
          path: "/_",
          component: Dashboard,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        // COMPANY
        {
          path: "/company",
          component: Company,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/editCompany/:id",
          component: EditCompany,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
       
        // USER
        {
          path: "/users",
          component: User,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createUser",
          component: CreateUser,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editUser/:id",
          component: EditUser,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/changePassword/:id",
          component: ChangePassword,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // TEACHER
        {
          path: "/teacher",
          component: Teacher,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createTeacher",
          component: CreateTeacher,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editTeacher/:id",
          component: EditTeacher,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // GENERAL
        {
          path: "/general",
          component: General,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createCountry",
          component: CreateCountry,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editCountry/:id",
          component: EditCountry,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createUniversity",
          component: CreateUniversity,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editUniversity/:id",
          component: EditUniversity,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createUniversity",
          component: CreateUniversity,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editUniversity/:id",
          component: EditUniversity,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createCourse",
          component: CreateCourse,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editCourse/:id",
          component: EditCourse,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createLevel",
          component: CreateLevel,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editLevel/:id",
          component: EditLevel,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createSubmission",
          component: CreateSubmission,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editSubmission/:id",
          component: EditSubmission,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createOffer",
          component: CreateOffer,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editOffer/:id",
          component: EditOffer,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // LEAD
        {
          path: "/lead",
          component: Lead,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createLead",
          component: CreateLead,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editLead/:id",
          component: EditLead,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/viewLead/:id",
          component: ViewLead,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // TRAINING
        {
          path: "/training",
          component: Training,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createTraining",
          component: CreateTraining,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editTraining/:id",
          component: EditTraining,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/imageUpload/:id",
          component: ImageUpload,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // TRAININGTYPE
        {
          path: "/trainingType",
          component: TrainingType,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createTrainingType",
          component: CreateTrainingType,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editTrainingType/:id",
          component: EditTrainingType,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editDetails/:id",
          component: EditDetails,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/registrationEdit/:id",
          component: RegistrationEdit,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        // Application
        {
          path: "/application",
          component: Application,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createApplication",
          component: CreateApplication,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/applicationDetail/:id",
          component: ApplicationDetail,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
      ]
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

export default router;
